import { useState, useEffect } from "react";
import { searchVenues, requestVenue } from "../../api/gift";

import "./styles/venue-search.css";

export default function VenueSearchStep({ gift, onVenueSet, onSkip }) {
  const [query, setQuery] = useState(gift.venueName || "");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!query || query.length < 2) {
      setResults([]);
      setNotFound(false);
      return;
    }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const venues = await searchVenues(query);
        setResults(venues);
        setNotFound(!venues.length);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [query]);

  const handleContinueMissing = async () => {
    try {
      await requestVenue(query);
    } catch (e) {
      /* ignore */
    }
    onVenueSet({ id: null, name: query, status: "missing" });
  };

  return (
    <section className="step venue-search fade-in">
      <h2>Search the venue</h2>

      <input
        id="venueSearch"
        name="venueSearch"
        className="text-input large"
        placeholder="Type venue name"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {(!query || query.length < 2) && (
        <button className="top-skip" onClick={onSkip}>
          Skip for now →
        </button>
      )}

      {loading && <p className="hint">Searching…</p>}

      {!!results.length && (
        <ul className="venue-results">
          {results.map((v) => (
            <li
              key={v.id}
              className="venue-card"
              onClick={() =>
                onVenueSet({ id: v.id, name: v.name, status: "found" })
              }
            >
              {v.photoUrl && <img src={v.photoUrl} alt="" />}
              <div>
                <h3>{v.name}</h3>
                <p>
                  {v.city || ""}
                  {v.city && v.state ? ", " : ""}
                  {v.state || ""}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}

      {notFound && (
        <div className="not-found-card">
          <h3>We don’t have that venue yet</h3>
          <p>Continue and we’ll add forecasts within 24 hours.</p>
          <button className="primary-btn" onClick={handleContinueMissing}>
            Continue
          </button>
        </div>
      )}

      {/* bottom skip stays for when there ARE results/notFound */}
      {query && query.length >= 2 && !loading && (
        <button className="link-btn" onClick={onSkip}>
          Skip for now →
        </button>
      )}
    </section>
  );
}
